import React from 'react';
import { Editorial, Typography, BorderRadius } from '../styles/primitives';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading...' }) => {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: Editorial.Paper }}
    >
      <div className="text-center">
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div
            className="absolute inset-0 border-4 animate-spin"
            style={{
              borderColor: '#ef4444 transparent transparent transparent',
              borderRadius: '50%',
              animationDuration: '1.2s',
            }}
          />
          <div
            className="absolute inset-2 border-4 animate-spin"
            style={{
              borderColor: '#000000 transparent transparent transparent',
              borderRadius: '50%',
              animationDuration: '1.5s',
              animationDirection: 'reverse',
            }}
          />
          <div
            className="absolute inset-4 border-4 animate-spin"
            style={{
              borderColor: '#ffffff transparent transparent transparent',
              borderRadius: '50%',
              animationDuration: '1.8s',
            }}
          />
        </div>
        <h2
          className="font-semibold mb-2"
          style={{
            color: Editorial.Ink,
            fontSize: Typography.HeadlineLarge,
            fontWeight: Typography.WeightSemibold,
            lineHeight: Typography.LeadingTight,
          }}
        >
          {message}
        </h2>
        <p
          style={{
            color: Editorial.InkMedium,
            fontSize: Typography.BodySmall,
            lineHeight: Typography.LeadingNormal,
          }}
        >
          Please wait while we load your trading platform
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;